import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const AuthConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID ?? "",
    authority: process.env.REACT_APP_AUTHORITY ?? "",
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITY ?? ""],
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage", // Changed this as sessions do not persist between tabs.
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_API_SCOPE ?? "openid"],
};
